import { API_BASE_URL as CONFIGURED_API_BASE_URL } from './apiConfig';

function trimSlash(s) {
  return String(s).trim().replace(/\/+$/, '');
}

function fromRuntime() {
  if (typeof window === 'undefined') return null;
  const v = window.__DTH_API_BASE_URL__;
  return v != null && String(v).trim() !== '' ? String(v).trim() : null;
}

/** Relative paths like /api/v1 are resolved against the browser host (nginx same-origin). */
function toAbsoluteApiBaseUrl(configured) {
  const v = String(configured).trim();
  if (v.startsWith('/')) {
    if (typeof window !== 'undefined' && window.location?.origin) {
      return trimSlash(`${window.location.origin}${v}`);
    }
    return trimSlash(v);
  }
  return trimSlash(v);
}

/**
 * Priority: runtime-config.js (if set) → apiConfig.js (comment switch).
 */
export function resolveApiBaseUrl() {
  return toAbsoluteApiBaseUrl(fromRuntime() || CONFIGURED_API_BASE_URL);
}

export function resolveCentralOrigin() {
  const base = resolveApiBaseUrl();
  if (base.startsWith('http://') || base.startsWith('https://')) {
    try {
      return new URL(base).origin;
    } catch {
      return base.replace(/\/api\/v1\/?$/i, '');
    }
  }
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }
  return 'http://localhost:8067';
}

export function resolveApiOrigin() {
  return resolveCentralOrigin();
}

export { CONFIGURED_API_BASE_URL as API_BASE_URL };
